import { render } from "./LabelSelect.vue?vue&type=template&id=7fb86b5c&scoped=true"
import script from "./LabelSelect.vue?vue&type=script&lang=js"
export * from "./LabelSelect.vue?vue&type=script&lang=js"

import "./LabelSelect.vue?vue&type=style&index=0&id=7fb86b5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb86b5c"]])

export default __exports__